import { NgModule } from '@angular/core'
import { TranslateModule } from '@ngx-translate/core'
import { CurrencyFormatPipe } from './currency-format/currency-format.pipe'
import { FormatDocumentNumberPipe } from './document-number-format/document-number-format.pipe'
import { GetControlPipe } from './get-control/get-control.pipe'
import { JoinNamesPipe } from './join-names/join-names.pipe'
import { TranslateMaintenanceStatusPipe } from './translate-maintenance-status/translate-maintenance-status.pipe'

@NgModule({
  declarations: [
    CurrencyFormatPipe,
    FormatDocumentNumberPipe,
    GetControlPipe,
    JoinNamesPipe,
    TranslateMaintenanceStatusPipe
  ],
  imports: [
    TranslateModule
  ],
  exports: [
    CurrencyFormatPipe,
    FormatDocumentNumberPipe,
    GetControlPipe,
    JoinNamesPipe,
    TranslateMaintenanceStatusPipe
  ]
})
export class PipesModule { }
